import { Search } from "lucide-react";

/**
 * Search field for a table toolbar.
 *
 * 40px rather than the 44px form Input: a filter sits above content rather than
 * inside a form, and the shorter control keeps the toolbar from competing with
 * the data it filters.
 *
 * The icon uses `start-3` and the field `ps-9`, so both flip with direction
 * without a single RTL-specific rule.
 */
export function SearchInput({
  value,
  onChange,
  placeholder,
  className = "",
  ariaLabel,
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  ariaLabel?: string;
}) {
  return (
    <div className={`relative min-w-[200px] flex-1 ${className}`}>
      <Search
        className="pointer-events-none absolute start-3 top-1/2 size-4 -translate-y-1/2 text-muted-subtle"
        aria-hidden="true"
      />
      <input
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={ariaLabel ?? placeholder}
        className="h-10 w-full rounded-lg border border-line-strong bg-card ps-9 pe-3 text-sm outline-none transition-colors focus:border-accent-500"
      />
    </div>
  );
}
